import React, {Component} from "react";
import {connect} from "react-redux";
import CarouselItem from "../../../../blocks/CarouselItem";
import Source from "../../../../items/Source";
import MiniLegend from "../../../../items/MiniLegend";
import {cloneAndRenameObj, calculateDomain, removeDecimalsIfNotNeeded, numberWithCommas} from "../../../../../helpers/formatters";

import {BarChart} from "d3plus-react";
import {textWidth} from "d3plus-text";

class LaborMarketOutcomesRegion extends Component {

  constructor(props) {
    super();
    this.state = {
      config1: {},
      config2: {},
      config3: {},
      config4: {},
      config5: {},
      config6: {},
      config7: {},
      config8: {},
      colors: []
    };
    this.createConfigs = this.createConfigs.bind(this);
  }

  componentDidMount() {
    this.createConfigs(this.props.nuts3Data, this.props.clustersData, this.props.selectedRegion, 0);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.clustersData.length !== nextProps.clustersData.length || this.props.nuts3Data.length !== nextProps.nuts3Data.length) {
      this.createConfigs(nextProps.nuts3Data, nextProps.clustersData, nextProps.selectedRegion, 0);
    }
    if (
      this.props.selectedRegion.id !== nextProps.selectedRegion.id
    ) {
      this.createConfigs(nextProps.nuts3Data, nextProps.clustersData, nextProps.selectedRegion, 300);
    }
    if (
      this.state.config1 !== nextState.config1 ||
      this.state.config2 !== nextState.config2 ||
      this.state.config3 !== nextState.config3 ||
      this.state.config4 !== nextState.config4 ||
      this.state.config5 !== nextState.config5 ||
      this.state.config6 !== nextState.config6 ||
      this.state.config7 !== nextState.config7 ||
      this.state.config8 !== nextState.config8
    ) {
      return true;
    }
    return false;
  }

  createConfigs(nuts3Data, clustersData, selectedRegion, delayMS) {
    const selectedRegionID = selectedRegion.id;
    const nuts3Datum = nuts3Data.find(n3 => n3.id === selectedRegionID);

    if (!nuts3Datum) {
      return '';
    }
    const avgData = clustersData.find(cd => cd.cluster_id === nuts3Datum.cluster_id);

    if (!avgData) {
      return '';
    }
    avgData.color = "#cccccc";
    avgData.name = `${avgData.cluster_name} Cluster average`;

    //avgData.net_job_growth_2011_18 = avgData.net_job_growth_2011_18 / 100;
    //avgData.working_age_population_2018_in_thousands = avgData.working_age_population_2018_in_thousands / 100;

    //console.log(Object.keys(avgData));
    //console.log(Object.keys(nuts3Datum));

    const renameFields = {
      'nuts_3_region_net_job_growth_2011_18_percent': 'net_job_growth_2011_18_in_percent',
      'nuts_3_region_gdp_per_capita_2013_17': 'gdp_per_capita_2013_17_in_thousands',
      'nuts_3_region_employment_rate_2018': 'employment_rate_2018_share',
      'nuts_3_region_unemployment_rate_2014_18': 'unemployment_rate_2018_share',
      'nuts_3_region_working_age_population_2018_in_thousands': 'working_age_population_2018_in_thousands',
      'nuts_3_region_working_age_population_growth_2011_18_in_share': 'working_age_population_growth_2011_18_in_share',
      'nuts_3_region_net_migration_2018': 'net_migration_2018',
      'nuts_3_region_old_age_dependency_ratio_2014_18': 'old_age_dependency_ratio_2014_18',
      'name': 'name'
    };

    const smallNuts3Data = cloneAndRenameObj(nuts3Datum, renameFields);
    smallNuts3Data.color = "#38bdf3";

    const filteredData = [
      avgData,
      smallNuts3Data
    ];

    //console.log(filteredData);

    const colors = filteredData.map(d => ({color: d.color, label: d.name}));

    const varFormatters = [
      x => `${removeDecimalsIfNotNeeded((x * 100).toFixed(1))}%`,
      x => `${x.toFixed(0)}`,
      x => `${removeDecimalsIfNotNeeded((x * 100).toFixed(1))}%`,
      x => `${removeDecimalsIfNotNeeded(x.toFixed(1))}%`,
      x => `${numberWithCommas(x.toFixed(0))}`,
      x => `${(x * 100).toFixed(1)}%`,
      x => `${removeDecimalsIfNotNeeded(x.toFixed(1))}`,
      x => `${removeDecimalsIfNotNeeded(x.toFixed(1))}`
    ];

    const longerNames = [
      "Net job growth 2007-18",
      "GDP per capita in Euros, thousands, 2013-18",
      "Employment rate 2018",
      "Unemployment rate 2018",
      "Working-age population",
      "Working-age population growth",
      "Net migration rate",
      "Old-age dependency ratio"
    ];

    const fields = {
      'net_job_growth_2011_18_in_percent': '<b>Net job growth</b>, 2007-18',
      'gdp_per_capita_2013_17_in_thousands': '<b>GDP per capita</b>, 2013-18',
      'employment_rate_2018_share': '<b>Employment rate</b>, 2018',
      'unemployment_rate_2018_share': '<b>Unemployment rate</b>, 2018',
      'working_age_population_2018_in_thousands': 'Working age population, 2018, thousands',
      'working_age_population_growth_2011_18_in_share': '<b>Working age population growth, 2007-18</b>',
      'net_migration_2018': '<b>Net migration rate</b>, 2018',
      'old_age_dependency_ratio_2014_18': '<b>Old-age dependency</b>, 2018'
    };

    let longestStr = 0;
    let xMaxes = [0, 0, 0, 0, 0, 0, 0, 0];
    let xMins = [0, 0, 0, 0, 0, 0, 0, 0];
    let dataSets = Object.keys(fields).map((f, idx) => {
      if (fields[f].length > longestStr) {
        longestStr = Math.ceil(textWidth(fields[f]));
      }
      const finalData = [];
      let value;
      filteredData.forEach(fd => {
        value = fd[f];
        finalData.push({name: fd.name, property: fields[f], value: value, color: fd.color});
        xMaxes[idx] = xMaxes[idx] < value ? value : xMaxes[idx];
        xMins[idx] = xMins[idx] > value ? value : xMins[idx];
      });
      return finalData;
    });
    let vizHeight = 78;
    let configs = dataSets.map((dataSet, idx) => {
      const myDomain = calculateDomain(xMins[idx], xMaxes[idx]);

      const chartConfigTemplate = {
        data: dataSet,
        groupBy: "name",
        discrete: "y",
        discreteCutoff: 0,
        // we want bars to appear evenly sized, but only show legend once
        legend: false,
        height: vizHeight,
        // 22.5 is a magic number.. it seems like the legend height takes up about 22.5 pixels
        y: "property",
        x: "value",
        tooltipConfig: {
          body: d => `<div>${longerNames[idx]}: ${varFormatters[idx](d.value)}</div>`
        },
        yConfig: {
          title: false,
          width: 120,
          minSize: 125,
          tickSize: 0,
          shapeConfig: {
            labelConfig: {
              fontColor: () => "#000",
              fontFamily: () => "'FOW Theinhardt', sans-serif",
              fontSize: () => 10,
              fontWeight: () => 700
            },
            stroke: "#efefef",
            strokeWidth: 1
          },
        },
        xConfig: {
          title: false,
          tickFormat: tick => `${varFormatters[idx](tick)}`,
          tickSize: 0,
          labels: myDomain.length > 0 ? [0] : [],
          domain: myDomain
        },
        shapeConfig: {
          fill: d => d.color,
          duration: 0,
          Bar: {
            label: (d) => (`${varFormatters[idx](d.value)}`)
          }
        },
        groupPadding: 0,
        barPadding: 2
      };
      if (delayMS > 0) {
        setTimeout(() => {
          this.setState({[`config${idx + 1}`]: chartConfigTemplate, colors: colors});
        }, delayMS * (idx + 1));
      }
      return chartConfigTemplate;

    });
    if (delayMS === 0) {
      this.setState({
        config1: configs[0],
        config2: configs[1],
        config3: configs[2],
        config4: configs[3],
        config5: configs[4],
        config6: configs[5],
        config7: configs[6],
        config8: configs[7],
        colors: colors
      });
    }
  }

  render() {
    const {clustersData, nuts3Data} = this.props;
    if (clustersData.length === 0 || nuts3Data.length === 0 ) {
      return '';
    }
    const {config1, config2, config3, config4, config5, config6, config7, config8, colors} = this.state;

    return (
      <CarouselItem title="Labor market outcomes">
        <>
          <div className="fow-col fow-col-1-2 fow-lg-col-1">
            <h2 className="fow-font-text fow-font-size-lg fow-carousel-item-block-subtitle"><b>Employment,</b> 2018</h2>
            <MiniLegend colors={colors} />
            <BarChart config={config1} />
            <BarChart config={config2} />
            <BarChart config={config3} />
            <BarChart config={config4} />
            <Source text="Source: Eurostat, Oxford Economics; McKinsey Global Institute analysis" />
          </div>
          <div className="fow-col fow-col-1-2 fow-lg-col-1">
            <h2 className="fow-font-text fow-font-size-lg fow-carousel-item-block-subtitle"><b>Population statistics,</b> 2018</h2>
            <MiniLegend colors={colors} />

            <BarChart config={config6} />
            <BarChart config={config7} />
            <BarChart config={config8} />
            <Source text="Source: Eurostat, Oxford Economics; McKinsey Global Institute analysis" />
          </div>
        </>
      </CarouselItem>
    );
  }
}

const mapStateToProps = state => {
  return {
    nuts3Data: state.db.data.facts.nuts3 ? state.db.data.facts.nuts3 : [],
    clustersData: state.db.data.facts.clusters_avg ? state.db.data.facts.clusters_avg : [],
    selectedRegion: state.settings.map["Regions"]
  };
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(LaborMarketOutcomesRegion);
